import { IsString } from 'class-validator';

export class PasswordlessLoginModel {
  @IsString()
  declare session: string;
}
